import { render, staticRenderFns } from "./TabContactInfo.vue?vue&type=template&id=c5900050&scoped=true&"
import script from "./TabContactInfo.vue?vue&type=script&lang=js&"
export * from "./TabContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5900050",
  null
  
)

export default component.exports